import { render, staticRenderFns } from "./addProfit.vue?vue&type=template&id=334126e0&scoped=true&"
import script from "./addProfit.vue?vue&type=script&lang=js&"
export * from "./addProfit.vue?vue&type=script&lang=js&"
import style0 from "./addProfit.vue?vue&type=style&index=0&id=334126e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334126e0",
  null
  
)

export default component.exports